export function initials(name: string): string {
  return name
    .split(" ")
    .filter(Boolean)
    .slice(0, 2)
    .map((w) => w[0]?.toUpperCase())
    .join("");
}

// "2026-10" -> "October 2026". Anything that is not a YYYY-MM string is returned unchanged.
export function fmtMonth(ym: string | null | undefined): string {
  const m = /^(\d{4})-(0[1-9]|1[0-2])$/.exec(String(ym ?? ""));
  if (!m) return String(ym ?? "");
  return new Date(Number(m[1]), Number(m[2]) - 1, 1).toLocaleDateString("en-IN", { month: "long", year: "numeric" });
}
